import { Component, DestroyRef, HostListener, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from './shared/libs/auth/auth.service';
import { Router } from '@angular/router';

@Component({
	standalone: false,
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent {
	@HostListener('window:beforeunload', ['$event'])
	onBeforeUnload(event: BeforeUnloadEvent) {
		localStorage.setItem('url', this.#router.routerState.snapshot.url);
	}

	readonly #authService = inject(AuthService);
	readonly #destroyRef = inject(DestroyRef);
	readonly #router = inject(Router);

	constructor() {
		this.check();
	}

	check(): void {
		const url = localStorage.getItem('url');
		localStorage.removeItem('url');

		this.#authService.getUserLogged.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((user) => {
			if (user && (!user?.Roles || user?.Roles.length === 0)) {
				const companySelected = document.cookie.split(';').find((cookie) => cookie.trim().startsWith('COMPANY_SELECTED='));

				if (companySelected) {
					this.#authService
						.authentication(this.#router.routerState.snapshot, Number(companySelected.split('=')[1]))
						.pipe(takeUntilDestroyed(this.#destroyRef))
						.subscribe((res: any) => {
							// La company del cookie può non valere più: basta aver cambiato profilo su
							// un'altra piattaforma BasicNet. Senza ruoli entrare nell'area significa
							// /error/forbidden, quindi si riparte dalla scelta della company.
							if (!this.#authService.userLoggedValue?.Roles?.length) {
								this.#authService.clearCompanySelected();
								this.#router.navigate(['/user/company-selection']);
								return;
							}

							if (url) {
								this.#router.navigate([url]);
							} else {
								this.#router.navigate(['/company/']);
							}
						});
				} else {
					this.#router.navigate(['/user/company-selection']);
				}
			}
		});
	}
}
